module.exports = __webpack_public_path__ + "static/media/Landing_page1.90d3428b.jpg";